/**
 * Friendly error messages for common Supabase/Postgres error codes.
 */
export function parseDatabaseError(error: unknown): string {
  if (!error || typeof error !== 'object') return 'An unexpected error occurred.';

  const err = error as { code?: string; message?: string; details?: string };

  switch (err.code) {
    case '23505':
      return 'A record with this information already exists. Please check for duplicates.';
    case '23503':
      return 'This record is referenced by other data and cannot be removed.';
    case '23514':
      return 'The data provided violates a database constraint. Please check your input.';
    case '42501':
      return 'You do not have permission to perform this action.';
    case 'PGRST116':
      return 'Record not found.';
    case 'PGRST301':
      return 'Session expired. Please log in again.';
    default:
      return err.message || 'An unexpected database error occurred. Please try again.';
  }
}
